import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/AppProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutClientInner"] */ "/vercel/path0/apps/web/app/layout-client-inner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadingProvider","useLoading"] */ "/vercel/path0/apps/web/components/default/loading/LoadingContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/styles/prosemirror.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/katex@0.16.25/node_modules/katex/dist/katex.min.css");
